import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 1rem 0.6rem
`

export const Submit = styled.input`
  width: 16rem;
  height: 2.5rem;
  &:hover {
    transition: 200ms ease-in-out;
    background-color: #2dca98;
  }
`

export const Form = styled.form`
  align-items: center;
`

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1220px;
  align-items: center;
  margin-bottom: 15px
`

export const TotalItems = styled.div`
  font-weight: 500;
`
